export default __webpack_public_path__ + "static/media/courses_icon.cf9f02e6.svg";